import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import SideBySideWithIconsTextAndAssetDekstopComponent from "./side-by-side-with-icons-text-and-asset-dekstop-component.js";
import SideBySideWithIconsTextAndAssetMobileComponent from "./side-by-side-with-icons-text-and-asset-mobile-component.js";

export default withResponsiveHOC(
  SideBySideWithIconsTextAndAssetDekstopComponent,
  SideBySideWithIconsTextAndAssetMobileComponent
);
